import React from 'react'
import { makeStyles, Select, MenuItem } from '@material-ui/core'
import { relationOptions } from '../../utils/constants'
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown'

const useStyles = makeStyles(theme => ({
  relationship: {
    width: '100%',
    [theme.breakpoints.down('500')]: {
      width: '100%'
    },
    [theme.breakpoints.down('1800')]: {
      width: '100%'
    },
    borderRadius: '8px !important',
    fontFamily: 'Source Sans Pro',
    fontSize: '16px',
    border: `1px solid  rgb(173, 184, 204)`,
    outline: 'none !important',
    padding: '8px !important',
    '& svg': {
      marginRight: '5px',
      color: `${theme.palette.primary.dark}`
    }
  },
  hover: {
    '& div:first-child:hover': {
      borderColor: `${theme.palette.primary.light}`
    }
  }
}))

const RelationSelect = props => {
  const classes = useStyles()
  const { input, rootClass } = props
  const customIcon = props => <ArrowDropDownIcon {...props} />

  return (
    <div className={`${classes.hover} ${rootClass}`}>
      <Select
        displayEmpty
        className={classes.relationship}
        disableUnderline
        MenuProps={{
          anchorOrigin: {
            vertical: 'bottom',
            horizontal: 'left'
          },
          getContentAnchorEl: null
        }}
        IconComponent={customIcon}
        {...input}
      >
        {relationOptions.map(relation => (
          <MenuItem
            key={relation.value}
            value={relation.value}
            disabled={relation.disabled}
          >
            {relation.label}
          </MenuItem>
        ))}
      </Select>
    </div>
  )
}

export default RelationSelect
